module.exports = __webpack_public_path__ + "static/closetdoctor-6f9d630192d6556054b3c23f1273bc74.jpg";